<template>
    <div class="result-card__tags" v-if="filteredTagGroups.length>0" >
        <div class="result-card__tags-group" v-for="tagGroup in filteredTagGroups" :key="tagGroup.Name">
            <span>{{ tagGroup.Name }}</span>
            <ul class="result-card__tags-list">
                <li v-for="(tag, tagIndex) in tagGroup.Children" :key="tagIndex" class="result-card__tag">
                    {{ tag }}
                </li>
            </ul>
        </div>
    </div>
</template>

<script>
    export default {
        name: 'ResultTags',
        props: {
            tagParents: {
                type: Array,
                required: true,
                default: () => []
            }
        },
        computed: {
            tagsShownOnResults() {
                return this.$store.state.search.tagsShownOnResults || []
            },
            filteredTagGroups() {
                if (!Array.isArray(this.tagParents) || !this.tagParents.length || !Array.isArray(this.tagsShownOnResults) || !this.tagsShownOnResults.length) {
                    return []
                }
                const tagGroupsMap = new Map(this.tagParents.map(group => [group.Name, group]))

                return this.tagsShownOnResults
                    .map(tagToShow => tagGroupsMap.get(tagToShow.Name))
                    .filter(Boolean)
            }
        }
    }
</script>